import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output';

const Resume8 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="max-w-[900px] mx-auto my-5 bg-white grid grid-cols-2 gap-5 shadow-md" style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }} ref={resumeRef}>
        <header className="col-span-2 flex justify-between items-center bg-[#333] text-white p-5">
          <div className="left-header">
            <h1 className="m-0 text-[2.5em] tracking-wider">{ResumeStore.resumeBuilder.personalDetails.firstName}</h1>
            <h1 className="m-0 text-[2.5em] tracking-wider">{ResumeStore.resumeBuilder.personalDetails.lastName}</h1>
          </div>
          <div className="right-header text-[1.2em]">
            <p className="m-1">Graphic Designer</p>
            <p className="m-1">UI/UX Engineer</p>
            <p className="m-1">Developer</p>
          </div>
        </header>
        <section className="profile bg-[#f0f0f0] p-5 border-t-[5px] border-[#333]">
          <h2 className="text-[1.5em] mb-2">PROFILE</h2>
          <p>{ResumeStore.resumeBuilder.profileSummary}</p>
        </section>
        <section className="contact bg-[#008b8b] text-white p-5">
          <h2 className="text-[1.5em] mb-2">CONTACT</h2>
          <p>📞 {ResumeStore.resumeBuilder.personalDetails.phone}</p>
          <p>💼 {ResumeStore.resumeBuilder.personalDetails.jobTitle}</p>
          <p>📧 {ResumeStore.resumeBuilder.personalDetails.email}</p>
          <p>🌐 {ResumeStore.resumeBuilder.websites.map(website => website.link).join(', ')}</p>
        </section>
        <section className="experience bg-[#f0f0f0] p-5 border-t-[5px] border-[#333] col-span-2">
          <h2 className="text-[1.5em] mb-2">EXPERIENCE</h2>
          {ResumeStore.resumeBuilder.employementHistory.map((job, index) => (
            <div key={index} className="mb-5">
              <h3 className="text-[1.2em] font-bold">{job.company}</h3>
              <p className="float-right text-[1em] text-white">{job.startDate} - {job.endDate}</p>
              <p>{job.description}</p>
            </div>
          ))}
        </section>
        <section className="skills bg-[#008b8b] text-white p-5">
          <h2 className="text-[1.5em] mb-2">SKILLS</h2>
          <ul className="list-none p-0">
            {ResumeStore.resumeBuilder.skills.map((skill, index) => (
              <li key={index} className="text-[1.2em] mb-2">{skill}</li>
            ))}
          </ul>
        </section>
        <section className="education bg-[#008b8b] text-white p-5">
          <h2 className="text-[1.5em] mb-2">EDUCATION</h2>
          {ResumeStore.resumeBuilder.education.map((edu, index) => (
            <div key={index} className="mb-5">
              <h3 className="text-[1.2em] font-bold">{edu.school}</h3>
              <p className="float-right text-[1em] text-white">{edu.startDate} - {edu.endDate}</p>
              <p>{edu.degree}</p>
            </div>
          ))}
        </section>
      </div>
    </>
  ));
}

export default Resume8;
